import {Record} from 'immutable';

// The API sends more fields back, but we don't need them yet.
export default class CoachingReviewFeedback extends Record({
  id: null,
  reviewFileuploadId: null,
}) {
  constructor(object = {}) {
    super({
      id: object.id,
      reviewFileuploadId: object.reviewFileuploadId,
    });
  }
}
